export const selectOptionsUnitLeaseTypes = [
  "12-Month Lease - Occupied",
  "24-Month Lease",
  "Greater than 3-year lease",
  "Month-to-Month",
  "12-Month Lease - Signed with Deposit",
  "Vacant",
  "Short-Term Rental",
  "TBD",
];
